import { TrendingUp, Wallet, ArrowUpRight } from "lucide-react";
import { useData } from "../../hooks/useData";
import { Reveal } from "../ui-custom/Reveal";
import Counter from "../ui-custom/Counter";

// Interactive glass dashboard mockup driven by gallery.json.
export default function Dashboard() {
  const { data } = useData("gallery");
  if (!data) return null;
  const max = Math.max(...data.chart);

  return (
    <Reveal className="relative" data-testid="dashboard-preview">
      <div className="rounded-[2rem] glass-strong p-5 sm:p-8">
        <div className="mb-6 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <span className="h-3 w-3 rounded-full bg-red-400" />
            <span className="h-3 w-3 rounded-full bg-amber-400" />
            <span className="h-3 w-3 rounded-full bg-emerald-400" />
          </div>
          <span className="text-xs text-slate-400"> easytek.co.in / dashboard</span>
        </div>

        <div className="grid gap-5 lg:grid-cols-[1.4fr_1fr]">
          <div className="space-y-5">
            <div className="flex items-center justify-between rounded-2xl bg-brand-soft p-5">
              <div>
                <div className="flex items-center gap-2 text-xs text-slate-500"><Wallet size={14} /> {data.wallet.label}</div>
                <p className="mt-1 text-3xl font-bold text-slate-900">{data.wallet.balance}</p>
              </div>
              <span className="flex items-center gap-1 rounded-full bg-white px-3 py-1 text-sm font-semibold text-brand-2 shadow-sm">
                <TrendingUp size={14} /> {data.wallet.change}
              </span>
            </div>

            <div className="rounded-2xl bg-white p-5 shadow-sm">
              <p className="mb-4 text-sm font-medium text-slate-700">Monthly volume</p>
              <div className="flex h-36 items-end gap-1.5">
                {data.chart.map((v, i) => (
                  <div key={i} className="flex-1 rounded-t-md bg-brand-gradient opacity-80 transition-all duration-300 hover:opacity-100" style={{ height: `${(v / max) * 100}%` }} />
                ))}
              </div>
            </div>

            <div className="grid grid-cols-3 gap-3">
              {data.metrics.map((m, i) => (
                <div key={i} className="rounded-2xl bg-white p-4 shadow-sm">
                  <p className="text-[11px] text-slate-400">{m.label}</p>
                  <p className="mt-1 text-lg font-bold text-slate-900">
                    <Counter value={parseInt(m.value.replace(/[^\d]/g, ""), 10)} />
                  </p>
                  <span className="text-xs text-brand-2">{m.change}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-2xl bg-white p-5 shadow-sm">
            <div className="mb-4 flex items-center justify-between">
              <p className="text-sm font-medium text-slate-700">Recent transactions</p>
              <ArrowUpRight size={16} className="text-slate-400" />
            </div>
            <div className="space-y-3">
              {data.transactions.map((t, i) => (
                <div key={i} className="flex items-center justify-between rounded-xl bg-slate-50 px-3 py-2.5">
                  <div>
                    <p className="text-sm font-medium text-slate-900">{t.type}</p>
                    <p className="text-[11px] text-slate-400">{t.time}</p>
                  </div>
                  <div className="text-right">
                    <p className="text-sm font-semibold text-slate-900">{t.amount}</p>
                    <span className={`text-[11px] ${t.status === "Success" ? "text-brand-2" : "text-amber-500"}`}>{t.status}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </Reveal>
  );
}
